import { BaseService } from './../base'
export class StablishmentService extends BaseService {
    static get entity () {
        return 'stablishment'
    }
    static get name () {
        return 'stablishment'
    }
}